enum SessionOrigin {
  SCO = 'sco',
  App = 'app',
}

export default SessionOrigin;
